var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TotemSelect',{staticClass:"select-language",attrs:{"options":_vm.languages,"value":_vm.getSelectedLanguage,"clearable":false,"width":160,"theme":_vm.theme,"languageSelector":""},on:{"input":_vm.setSelectedLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }